import { Outlet } from 'react-router-dom'

function Layout() {
  return (
    <main className="App bg-transparent">
      <Outlet />
    </main>
  )
}

export default Layout
